import React, { useState } from 'react'
import notificationToast from 'helpers/notificationToast'
import LinkIcon from '@material-ui/icons/Link'
import { toast } from 'react-toastify'
import TealToolTip from 'components/TealToolTip'
import IconButton from '@material-ui/core/IconButton'
import CommentIcon from '@material-ui/icons/Chat'

const ParameterComment = ({ comment }) => {
  const [open, setOpen] = useState(false)

  const handleOnClick = () => {
    navigator.clipboard.writeText(comment)
    notificationToast(<LinkIcon />, toast.TYPE.INFO, 'Comment copied to clipboard')
    setOpen(!open)
  }

  if (!comment) return null

  return (
    <TealToolTip
      title={comment}
      placement='top'
      open={open}
    >
      <IconButton
        size='small'
        classes={{ sizeSmall: 'pa3' }}
        onClick={handleOnClick}
        data-clipboard-text={comment}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        data-testid='parameter-comment-icon'
      >
        {open
          ? <LinkIcon className='w7 vm dark-sea-green-2 mt1' />
          : <CommentIcon className='w7 vm dark-sea-green-2 mt1' />}
      </IconButton>
    </TealToolTip>
  )
}

export default ParameterComment
